export default {
  localization: {
    defaultLocale: 'de',
  },
  analytics: {
    google: '',
  },
  header: {
    fixed: false,
    offset: 0,
    offsetMobile: 0,
  },
  recaptcha: {
    key: '6Lfq2-UUAAAAAJMywrnvYwXP2XoommnctUs_uGBG',
  },
  validate: {
    bookingReference: (field) => {
      const BOOKING_CODE_FORMAT = /^[A-Z0-9]{6}$/i
      const TICKET_NUMBER_FORMAT = /^(220|724|257|082)-?\d{10}$/

      return (BOOKING_CODE_FORMAT.test(field.value) || TICKET_NUMBER_FORMAT.test(field.value)) ? '' : 'invalid'
    },
  },
}
